import React from 'react'
import { Container } from 'react-bootstrap'
import styles from './PlainHeader.module.scss'

const PlainHeader = ({ altLogo = 'Samsung Knox' }) => {
  return (
    <Container className={styles.header}>
      <img
        className="navbar-brand"
        src="https://kp4-cdn.samsungknox.com/resource/Logo_WpCU.svg"
        alt={altLogo}
        height="16"
      />
    </Container>
  )
}

export default PlainHeader
